// Tools合集页面导航配置 badge 支持 热门、新、推荐
export const toolsConfig = [
  {
    id: 1,
    title: "内部工具",
    description: "当前站点内部路由工具————原导航列表",
    icon: "Monitor",
    type: "group",
    children: [
      {
        id: 101,
        title: "模板报表",
        description: "自定义模板报表生成工具",
        icon: "Document",
        type: "internal",
        route: "/template-report",
        badge: "热门",
      },

      {
        id: 102,
        title: "周期任务",
        description: "多种周期任务配置",
        icon: "Setting",
        type: "internal",
        route: "/cycle-task-job",
        badge: "热门",
      },
      {
        id: 103,
        title: "转发Api",
        description: "为三方接口配置Api转发调用服务",
        icon: "Platform",
        type: "internal",
        route: "/dw-api",
        badge: "新",
      },
      {
        id: 104,
        title: "渠道流量",
        description: "提供Dataworks渠道流量数据导出",
        icon: "TrendCharts",
        type: "internal",
        route: "/channel-flow",
        badge: "推荐",
      },
      {
        id: 105,
        title: "短链生成工具",
        description: "淘宝、云片短链转换",
        icon: "Link",
        type: "internal",
        route: "/tools-shot-link",
        badge: "新",
      },
      // {
      //   id: 106,
      //   title: '文件互传',
      //   description: 'P2P局域网文件互传工具',
      //   icon: 'Connection',
      //   type: 'internal',
      //   route: '/file-chat',
      //   badge: '新'
      // },
      {
        id: 107,
        title: "双重安全验证",
        description: "双重安全验证跳过工具",
        icon: "Unlock",
        type: "internal",
        route: "/tools-double-verification",
        badge: "新",
      },
      {
        id: 108,
        title: "埋点原始数据查询",
        description: "埋点原始数据查询工具",
        icon: "Unlock",
        type: "internal",
        route: "/tracking-data-query",
        badge: "新",
      },
      {
        id: 109,
        title: "授权指南",
        description: "京东/淘宝授权配置指南和链接生成工具",
        icon: "Setting",
        type: "internal",
        route: "/authorization-guide",
        badge: "新",
      },
      {
        id: 110,
        title: "chanel-c2b转换",
        description: "香奈儿c2b音频转换操作指南",
        icon: "Setting",
        type: "internal",
        route: "/chanel-c2b-translate",
        badge: "新",
      },
      {
        id: 111,
        title: "Burton数据看板",
        description: "Burton小程序访问与订单核心数据看板",
        icon: "TrendCharts",
        type: "internal",
        route: "/burton-dashboard",
        badge: "新",
      },
      {
        id: 112,
        title: "excel行列提取转换",
        description: "支持粘贴/上传Excel，按列配置快速做行列表头转换与导出",
        icon: "Edit",
        type: "internal",
        route: "/excel-pivot-transform",
        badge: "新",
      },
      {
        id: 113,
        title: "日志服务查询",
        description: "SLS日志服务查询工具，支持多平台日志查询",
        icon: "Document",
        type: "internal",
        route: "/sls-log-query",
        badge: "新",
      },
    ],
  },
  {
    id: 2,
    title: "外部工具",
    description: "By Cola提供的外部工具",
    icon: "Setting",
    type: "group",
    children: [
      {
        id: 21,
        title: "Jar编辑",
        description: "为jar包修改配置文件的工具",
        icon: "Tools",
        type: "external",
        url: "https://jar.nxqlhhk.top/",
        target: "_blank",
        badge: "新",
      },
      {
        id: 22,
        title: "数据格式化工具",
        description: "常用数据格式化工具，支持Json、DataWorks数据、Sql等",
        icon: "Edit",
        type: "external",
        url: "https://tools.nxqlhhk.top/",
        target: "_blank",
        badge: "新",
      },
      {
        id: 23,
        title: "产品化数据商品比对",
        description: "产品化数据商品比对工具",
        icon: "Brush",
        type: "external",
        url: "https://item.nxqlhhk.top/",
        target: "_blank",
        badge: "新",
      },
      {
        id: 24,
        title: "公网Ip获取",
        description: "公网Ip获取工具",
        icon: "Link",
        type: "external",
        url: "https://ip.nxqlhhk.top/",
        target: "_blank",
        badge: "新",
      },
      {
        id: 25,
        title: "上传OSS脚本工具",
        description: "服务器获取日志等文件上传工具",
        icon: "Brush",
        type: "external",
        url: "https://oss-upload.nxqlhhk.top/",
        target: "_blank",
        badge: "新",
      },
    ],
  },
  {
    id: 3,
    title: "外链工具",
    description: "常用第三方工具链接",
    icon: "Link",
    type: "group",
    children: [
      {
        id: 31,
        title: "Json在线解析",
        description: "Json在线解析工具",
        icon: "Link",
        type: "external",
        url: "https://www.json.cn/",
        target: "_blank",
        badge: "新",
      },
    ],
  },
  {
    id: 4,
    title: "订单清洗",
    description: "订单清洗相关工具",
    icon: "Link",
    type: "group",
    children: [
      {
        id: 41,
        title: "淘宝订单清洗",
        description: "淘宝订单清洗工具",
        icon: "Link",
        type: "internal",
        route: "/tb-order-clean",
        badge: "新",
      },
      {
        id: 42,
        title: "JD订单清洗",
        description: "JD订单清洗工具",
        icon: "Link",
        type: "external",
        url: "https://t-jdlbx.nike.com.cn/order-push/web/",
        target: "_blank",
        badge: "新",
      },
    ],
  },
];
